import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IProductAISuggestRequest, IProductSuggestRequest } from '../models/ProductSuggestListModel'

export class UpdateProductAISuggestApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productSuggest/updateProductAISuggest',
      requesterInfo,
    })
  }

  public async updateProductSuggest(request: IProductAISuggestRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
